import { Outlet } from "react-router-dom"

const About = () => {
  return (
    <><h4>About page</h4>
      <Outlet></Outlet>
    </>
 
  )
}
export default About